import React, {useEffect, useMemo} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const CardsContent = ({data, boName }) => {

    const total = useMemo(() => {
        if (!data?.result?.length) return {dispatch: 0, occurrence: 0, individuals: 0, vehicles: 0};

        return data.result.reduce((acc, item) => {
            acc.dispatch = Math.max(acc.dispatch, Number(item.totalDispatch?.all_dispatch ?? 0));
            acc.occurrence = Math.max(acc.occurrence, Number(item.totalOccurrence?.occurrences ?? 0));
            acc.individuals = Math.max(acc.individuals, Number(item.encounterDataCard?.allindividuals ?? 0));
            acc.vehicles = Math.max(acc.vehicles, Number(item.encounterDataCard?.allvehicles ?? 0));

            return acc;
        }, {dispatch: 0, occurrence: 0, individuals: 0, vehicles: 0});

    }, [data]);

    useEffect(() => {
        const summaryLabels = [
            "Plantões analisados",
            "Total despachos",
            `Total ${boName}`,
            "Abordagens (Indivíduos)",
            "Abordagens (Veículos)"
        ];

        const summaryValues = [
            data.result[0].analyzedActivities?.all_actitivities ?? '0',
            total.dispatch,
            total.occurrence,
            total.individuals,
            total.vehicles
        ];

        ReportUtils.createExportableTable(summaryLabels, summaryValues, "Cards");
    }, [data, total]);

    return (
        <div className="grid grid-cols-4 gap-2 mb-5">
            <div className="text-center">
                <div className="box boxCount">
                    <h3>Plantões analisados</h3>
                    <h2>{data.result[0].analyzedActivities?.all_actitivities ?? '0'}</h2>
                </div>
            </div>

            <div className="text-center">
                <div className="box boxCount">
                    <h3>Total despachos</h3>
                    <h2>{total.dispatch}</h2>
                </div>
            </div>

            <div className="text-center">
                <div className="box boxCount">
                    <h3>Total {boName}</h3>
                    <h2>{total.occurrence}</h2>
                </div>
            </div>

            <div className="text-center">
                <div className="box boxCount">
                    <h3>Abordagens</h3>
                    <div className="boxSubTitle"><h5>Indivíduos</h5> <h5> | </h5> <h5>Veículos</h5></div>
                    <h2>{total.individuals} | {total.vehicles}</h2>
                </div>
            </div>
        </div>
    );
};

export default CardsContent;